import * as types from "./ActionTypes";
import Api from "../api/OrganizationApi";

class SettingsActions {
    constructor () {
    }

    getLogo (organizationId) {
        return (dispatch) => {
            return Api.getLogo(organizationId).then((result) => {
                dispatch({ type: types.GET_ORGANIZATION_LOGO_SUCCEEDED, result: result });
            })
                .catch((error) => {
                    dispatch({ type: types.GET_ORGANIZATION_LOGO_FAILED, error });
                });
        };
    }

    setLogo (logoValue) {
        return { type: types.SET_ORGANIZATION_LOGO, result: logoValue };
    }

    saveLogo (organizationId, logo) {
        return (dispatch) => {
            Api.saveLogo(organizationId, logo.fileType, logo.fileName, logo.fileAltName, logo.file).then(() => {
                dispatch({ type: types.SAVE_ORGANIZATION_LOGO_SUCCEEDED });
            })
                .catch((error) => {
                    dispatch({ type: types.SAVE_ORGANIZATION_LOGO_FAILED, error });
                });
        };
    }

    deleteLogo (organizationId) {
        return (dispatch) => {
            return Api.deleteLogo(organizationId).then(() => {
                dispatch({ type: types.DELETE_ORGANIZATION_LOGO_SUCCEEDED });
                dispatch(this.getLogo(organizationId));
            })
                .catch((error) => {
                    dispatch({ type: types.DELETE_ORGANIZATION_LOGO_FAILED, error });
                });
        };
    }

    //change actions
    setWebTimeout (value) {
        return { type: types.SETTINGS_SET_WEB_TIMEOUT, value: value };
    }

    setAccountLockoutInterval (value) {
        return { type: types.SETTINGS_SET_ACCOUNT_LOCKOUT_INTERVAL, value: value };
    }

    setAccountLockoutThreshold (value) {
        return { type: types.SETTINGS_SET_ACCOUNT_LOCKOUT_THRESHOLD, value: value };
    }

    setPasswordMaximumAge(value) {
        return { type: types.SETTINGS_SET_PASSWORD_MAXIMUM_AGE, value: value };
    }

    setPasswordMinimumLength(value) {
        return { type: types.SETTINGS_SET_PASSWORD_MINIMUM_LENGTH, value: value };
    }

    allowPasswordAlphabeticalCharacters(value) {
        return { type: types.SETTINGS_SET_ALLOW_PASSWORD_ALPHA_CHAR, value: value };
    }

    setPasswordAlphabeticalCharactersNumber (value) {
        return { type: types.SETTINGS_SET_PASSWORD_ALPHA_CHAR_NUMBER, value: value };
    }

    setPasswordNumericCharactersNumber (value) {
        return { type: types.SETTINGS_SET_PASSWORD_NUM_CHAR_NUMBER, value: value };
    }

    allowPasswordUppercaseCharacters (value) {
        return { type: types.SETTINGS_SET_ALLOW_PASSWORD_UPPERCASE, value: value };
    }

    setPasswordUppercaseCharactersNumber (value) {
        return { type: types.SETTINGS_SET_PASSWORD_UPPERCASE_NUMBER, value: value };
    }

    allowPasswordNumericCharacters (value) {
        return { type: types.SETTINGS_SET_ALLOW_PASSWORD_NUMERICS, value: value };
    }

    allowPasswordLowercaseCharacters (value) {
        return { type: types.SETTINGS_SET_ALLOW_PASSWORD_LOWERCASE, value: value };
    }

    setPasswordPunctuationOrOtherCharactersNumber (value) {
        return { type: types.SETTINGS_SET_PASSWORD_PUNCT_OTHER_CHAR_NUMBER, value: value };
    }

    allowPasswordPunctuationOrOtherCharacters (value) {
        return { type: types.SETTINGS_SET_ALLOW_PASSWORD_PUNCT_OTHER_CHAR, value: value };
    }

    setPasswordLowercaseCharactersNumber (value) {
        return { type: types.SETTINGS_SET_PASSWORD_LOWERCASE_CHAR_NUMBER, value: value };
    }

}

export const saveSettings = (settings) => {
    return (dispatch) => {
        return Api.saveSettings(settings).then(() => {
            dispatch({ type: types.SAVE_SETTINGS_SUCCEEDED });
        })
            .catch((error) => {
                dispatch({ type: types.SAVE_SETTINGS_FAILED, error });
            });
    };
};

export default new SettingsActions();

